// utils/pdfExportUtils.ts
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

interface ExportPDFOptions {
  fileName: string;
  columns: string[];
  data: any[];
  emptyDataMessage?: string;
  footerRow?: string[];
  autoTableOptions?: any;
}

export const exportToPDF = ({
  fileName,
  columns,
  data,
  emptyDataMessage = "No data available for export.",
  footerRow,
  autoTableOptions = {},
}: ExportPDFOptions) => {
  if (!data.length) {
    toast.warn(emptyDataMessage, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
    });
    return;
  }

  const doc = new jsPDF();

  const bodyData = [...data];
  if (footerRow) {
    bodyData.push(footerRow);
  }

  autoTable(doc, {
    head: [columns],
    body: bodyData,
    startY: 20,
    theme: "grid",
    ...autoTableOptions,
  });

  doc.save(`${fileName}.pdf`);
};
